import React, { useEffect, useState } from 'react'
import PageHeader from '../../components/page/PageHeader';
import axios from 'axios';
import { JSON_CONTENT_FORM_CONFIG } from '../../actions/Config';
import { useNavigate } from 'react-router-dom';
import { HomePageURL } from '../../assets/const';
import { getJSONContentFormConfig } from '../../actions/Config';

const CreateMove = () => {
    const [transfer, setTransfer] = useState(null);
    const [locations, setLocations] = useState([]);
    const [locationsFetching, setLocationsFetching] = useState(true);
    const [form, setForm] = useState({
        source_location: null,
        destination_location: null,
    })
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchLocations = async () => {
            try{
                let params = `page=10`
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/stock/fetch-available-locations/?${params}`, JSON_CONTENT_FORM_CONFIG);
                setLocationsFetching(false);
                if (res.status === 200){
                    setLocations(res.data);
                }
            }
            catch{}
        }
        if (locations.length === 0)
            fetchLocations()
    }, []);
    const handleFormChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let el = e.currentTarget;
        setForm({...form, [el.name]: el.value});
    }
    const validateForm = () => {
        if (!form.source_location || !form.destination_location || form.source_location === '0' || form.destination_location === '0')
            return false;
        // We can add more validations here
        return true;
    }
    const createTransfer = async () => {
        if (loading) return;
        if (!validateForm()) {
            window.alert("Please select both source and destination locations");
            return;}
        setLoading(true);
        try{
            const jsonConfig = getJSONContentFormConfig();
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/stock/create-transfer/`, JSON.stringify(form), jsonConfig);
            if (res.status === 200){
                navigate(`${HomePageURL}/stock-transfers/${res.data}/`, {replace: true});
            }
        }
        catch(err){
            window.alert(err?.response?.data?.error || 'An error occurred');
        }
        setLoading(false);
    }
  return (
    <>
        <PageHeader title="New Product Transfer" />
        <div className="row layout-top-spacing" id="cancel-row">
            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                <div className="widget-content widget-content-area br-6">
                    <div className="row">
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <label htmlFor='sourceLocationInput'>Source Location</label>
                                {locationsFetching ? 
                                <span>Fetching locations...</span>
                                :<select id="sourceLocationInput" name="source_location" onChange={handleFormChange} value={form.source_location} className='form-control' aria-describedby="sourceLocationInputHelp">
                                    <option value="0">Select source location</option>
                                    {
                                        locations.map(loc => {
                                            return (
                                                <option key={loc.id} value={loc.id}>{loc?.location_type === 'Warehouse Location' ? `Warehouse: ${loc?.warehouse?.name}` : loc?.location_type}</option>
                                            )
                                        })
                                    }
                                </select>}
                                <small id="sourceLocationInputHelp" className='form-text text-muted'>Select the source location</small>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <label htmlFor='destinationLocationInput'>Destination Location</label>
                                {locationsFetching ? 
                                <span>Fetching locations...</span>
                                :<select id="destinationLocationInput" name="destination_location" value={form.destination_location} onChange={handleFormChange}  className='form-control' aria-describedby='destinationLocationInputHelp'>
                                    <option value="0">Select destination location</option>
                                    {
                                        locations.map(loc => {
                                            return (
                                                <option key={loc.id} value={loc.id}>{loc?.location_type === 'Warehouse Location' ? `Warehouse: ${loc?.warehouse?.name}` : loc?.location_type}</option>
                                            )
                                        })
                                    }
                                </select>
                                }
                                <small id="destinationLocationInputHelp" className='form-text text-muted'>Select the destination location</small>
                                
                            </div>
                        </div>
                    </div>
                    <div className='d-flex mt-3' style={{flexDirection: "row-reverse"}}>
                        <button className="btn btn-primary" onClick={createTransfer} disabled={loading}>Save & Continue</button>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default CreateMove